enum VIEW_STATUSES {
  ALL = 'ALL',
  BAN = 'BAN',
  SHADOW = 'SHADOW',
  FACE = 'FACE',
}

export default VIEW_STATUSES;
